import React, { useState, useEffect, useRef } from "react";
import { flushSync } from "react-dom";
import "./paymentgetway.css";
import "./rightside.css";
import axios from "axios";
import { FaAngleDown, FaAngleUp, FaCheck, FaLock } from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaTruck } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";

import useNotification from "../../utils/useNotification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Loading, Navbar, Navbar2 } from "../../common";
import {
  add_user_check_product,
  check_coupons,
  check_coupons_new,
  cheke_state,
  createOrder_test,
  get_checkout_link_data,
  get_product_details,
  get_url_data,
  member_view,
  get_all_product_details_2,
} from "../../utils/Constant";
import images from "../../constants/images";
import usStates from "../../constants/usStates.json";
import { RiContactsFill, RiDiscountPercentLine } from "react-icons/ri";
import { MdOutlineCelebration, MdOutlinePayment } from "react-icons/md";
import { CiStar } from "react-icons/ci";
import { loadGoogleTag } from "../../utils/gtag";
import { Stethoscope, Truck } from "lucide-react";

const Checkout2 = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };
  const navigate = useNavigate();
  const location = useLocation();
  const { ID } = useParams();

  const name_data = location.state?.name_data;

  const handleGoBack = () => {
    navigate(-1); // This will navigate to the previous page
  };

  const [isloading, setIsLoading] = useState(false);
  const [isProductLoading, setIsProductLoading] = useState(false); // Separate loading state for product fetching
  const [isemailLoading, setIsEmailLoading] = useState(false);
  const [iscityloading, setIsCityLoading] = useState(false);
  const [getdata, setdata] = useState({});
  const [getproducts, setProducts] = useState([]); // New state for multiple products
  const [getproductPrice, setProductPrice] = useState("");
  const [getcdata, setCdata] = useState({});
  const [email, setEmail] = useState("");
  const [getuserData, setUserData] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [aptSuite, setAptSuite] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("United States");
  const [getstate, setState] = useState([]);
  const [postalCode, setPostalCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [billingSameAsShipping, setBillingSameAsShipping] = useState(false);
  const [shippingMethod, setShippingMethod] = useState("FREE SHIPPING");
  const [getcardid, setCardid] = useState(1);
  const [cardNumber, setCardNumber] = useState("");
  const [cardholdername, setcardholdername] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [exMonth, setExMonth] = useState("");
  const [exYear, setExYear] = useState("");
  const [cvv, setCvv] = useState("");
  const [id, setId] = useState(null);
  const [price, setPrice] = useState(null);
  const [getcampaignID, setCampaignID] = useState("");
  const [uniqueId, setUniqueId] = useState(null);
  const [getorder_id, setorder_id] = useState(null);
  const [getskipModel, setSkipModel] = useState(false);
  const [getthankyouURL, setThankyouURL] = useState("");

  const [discount_percent, setdiscount_percent] = useState(null);
  const [discount_amount, setdiscount_amount] = useState(null);
  
  // Store original product prices to prevent modification by m_price or other APIs
  const [originalProductPrices, setOriginalProductPrices] = useState(new Map());

  // shipping cost and name from API
  const [shippingCost, setShippingCost] = useState("0");
  const [newshippingCost, setNewShippingCost] = useState("0");
  const [shippingCode, setShippingCode] = useState("");
  const [shippingName, setShippingName] = useState("FREE SHIPPING");
  const [shippingId, setShippingId] = useState(null);
  const [newShippingId, setNewShippingId] = useState(null);

  // checkout link id from API
  const [checkoutLinkId, setCheckoutLinkId] = useState(null);
  const [hasCheckoutLinkPrices, setHasCheckoutLinkPrices] = useState(false);

  // section 2 conditions
  const [getsection2, setSection2] = useState(false);
  const [sameAsShipping, setSameAsShipping] = useState(true); // Default to same address

  //billing address start
  const [country2, setCountry2] = useState("");
  const [firstName2, setFirstName2] = useState("");
  const [lastName2, setLastName2] = useState("");
  const [address2, setAddress2] = useState("");
  const [city2, setCity2] = useState("");
  const [getselectedState2, setSelectedState2] = useState({
    name: "",
    state_code: "",
  });
  const [getselectedStateCode2, setSelectedStateCode2] = useState({
    name: "",
    state_code: "",
  });
  const [postalCode2, setPostalCode2] = useState("");
  const [phoneNumber2, setPhoneNumber2] = useState("");

  // promocode
  const [discountCode, setDiscountCode] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const [error, setError] = useState("");

  // Date of birth and gender for specific products (216, 199)
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [pendingStateToSet, setPendingStateToSet] = useState(null); // To handle state prefill timing

  // Helper function to parse discount value (handles commas, strings, numbers)
  const parseDiscountValue = (value) => {
    if (value == null || value === "" || value === undefined) return 0;
    // Convert to string, remove commas, then parse
    const cleanValue = String(value).replace(/,/g, "").trim();
    if (cleanValue === "0" || cleanValue === "0.00" || cleanValue === "") return 0;
    const parsed = parseFloat(cleanValue);
    return isNaN(parsed) ? 0 : parsed;
  };

  const handleApplyDiscount = async () => {
    setError(""); // Clear previous errors
    setApplyLoading(true); // Start loading
    try {
      // Get grouped products to handle quantities correctly
      const groupedProducts = getGroupedProductsForDisplay();
      
      // Calculate total price for all products (use consistent calculation)
      const totalPrice = getBaseTotalPrice();

      // Build product_id and qty arrays from grouped products
      const product_id = groupedProducts.map((product) => 
        parseInt(product.product_id)
      );
      const qty = groupedProducts.map((product) => 
        product.quantity || 1
      );

      // Use the new API endpoint with the correct payload structure
      const response = await axios.post(check_coupons_new, {
        promo_codes: discountCode,
        amount: totalPrice,
        product_id: product_id,
        qty: qty,
      });

      // Check the API response status
      if (response.data.status == 1) {
        setApplyLoading(false);
        setAppliedDiscount(response.data.data.code); // Store applied code
        
        // Parse and store discount values (handle comma-separated numbers)
        const discountPercent = parseDiscountValue(response.data.discount_percent);
        const discountAmount = parseDiscountValue(response.data.discount_amount);
        
        setdiscount_percent(discountPercent > 0 ? discountPercent : null);
        setdiscount_amount(discountAmount > 0 ? discountAmount : null);
        
        console.log("Coupon applied:", {
          code: response.data.data.code,
          discount_percent: discountPercent,
          discount_amount: discountAmount,
          basePrice: totalPrice
        });
      } else {
        setApplyLoading(false);
        setAppliedDiscount(null);
        setdiscount_percent(null);
        setdiscount_amount(null);
        notifyError(response.data.message || "Invalid code");
      }
    } catch (err) {
      setApplyLoading(false);
      setAppliedDiscount(null);
      setdiscount_percent(null);
      setdiscount_amount(null);
      setError("Something went wrong. Please try again.");
      notifyError(err.response?.data?.message || "Something went wrong. Please try again.");
    }
  };
  // Remove discount handler
  const handleRemoveDiscount = () => {
    setDiscountCode(""); // Clear the discount code input
    setAppliedDiscount(null); // Reset applied discount state
    setdiscount_percent(0); // Reset discount percent
    setdiscount_amount(0); // Reset discount amount
  };

  // promocode end

  // Determine if a discount is applied
  const isDiscountApplied = () => {
    const percentValue = parseDiscountValue(discount_percent);
    const amountValue = parseDiscountValue(discount_amount);
    return percentValue > 0 || amountValue > 0;
  };

  // Total text logic
  const totalText = isDiscountApplied() ? "Latest price" : "Your total";

  // Helper function to get base total price from products (ensures consistency)
  // Always uses original prices to prevent interference from m_price or other modifications
  const getBaseTotalPrice = () => {
    const productsToCalculate = getproducts?.length > 0 ? getproducts : (getdata?.product_price ? [getdata] : []);
    
    if (productsToCalculate.length === 0) {
      // Fallback to getproductPrice if no products available
      // BUT: Only use this if we truly have no products - never use m_price for discount calculations
      return parseFloat(getproductPrice) || 0;
    }

    // Calculate total from all products using original prices if available
    // This ensures m_price or other modifications don't affect discount calculations
    let total = 0;
    productsToCalculate.forEach((product) => {
      const productId = product.product_id;
      // Always prefer original price from our stored map
      const originalPrice = originalProductPrices.get(productId);
      if (originalPrice !== undefined) {
        total += originalPrice;
      } else {
        // If no original price stored, use current product_price
        // But also store it as original for future use
        const currentPrice = parseFloat(product.product_price || 0);
        if (productId && currentPrice > 0) {
          setOriginalProductPrices((prev) => {
            const newMap = new Map(prev);
            if (!newMap.has(productId)) {
              newMap.set(productId, currentPrice);
            }
            return newMap;
          });
        }
        total += currentPrice;
      }
    });
    
    return total;
  };

  // Helper function to calculate subtotal (product price after discount)
  const calculateSubtotal = () => {
    const basePrice = getBaseTotalPrice();
    
    if (isNaN(basePrice) || basePrice === 0) return 0;

    // Parse discount values using helper function (handles commas, strings, numbers)
    const discountPercentValue = parseDiscountValue(discount_percent);
    const discountAmountValue = parseDiscountValue(discount_amount);

    let discountedPrice = basePrice;

    // Priority: If discount_percent exists and is greater than 0, use percentage discount
    if (discountPercentValue > 0) {
      discountedPrice = basePrice - (basePrice * discountPercentValue / 100);
    } 
    // Otherwise, use discount_amount if it exists and is greater than 0
    else if (discountAmountValue > 0) {
      discountedPrice = basePrice - discountAmountValue;
    }

    // Ensure subtotal never goes below 0
    return Math.max(0, discountedPrice);
  };

  // Helper function to calculate total (subtotal + shipping)
  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const shipping = parseFloat(shippingCost) || 0;
    const total = subtotal + shipping;
    // Ensure total never goes below 0
    return Math.max(0, total);
  };

  // Helper function to calculate the discount amount being applied
  const getDiscountAmount = () => {
    const basePrice = getBaseTotalPrice();
    if (isNaN(basePrice) || basePrice === 0) return 0;

    // Use helper function to parse discount values (handles commas, strings, numbers)
    const discountPercentValue = parseDiscountValue(discount_percent);
    const discountAmountValue = parseDiscountValue(discount_amount);

    if (discountPercentValue > 0) {
      return basePrice * discountPercentValue / 100;
    } else if (discountAmountValue > 0) {
      return discountAmountValue;
    }
    return 0;
  };

  // Helper function to group products by product_id for display purposes only
  const getGroupedProductsForDisplay = () => {
    const productsToGroup = getproducts?.length > 0 ? getproducts : [getdata];
    const groupedMap = new Map();

    productsToGroup.forEach((product) => {
      const productId = product.product_id;
      if (groupedMap.has(productId)) {
        // Increment quantity if product already exists
        const existing = groupedMap.get(productId);
        existing.quantity = (existing.quantity || 1) + 1;
      } else {
        // Add new product with quantity 1
        groupedMap.set(productId, { ...product, quantity: 1 });
      }
    });

    return Array.from(groupedMap.values());
  };

  const [applyLoading, setApplyLoading] = useState(false);

  // check terms start
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  // check terms end

  const validateEmail = (email) => {
    // Basic email validation regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  // Helper function to check if id contains 216 or 199
  const requiresDOBAndGender = () => {
    if (!id) return false;
    const ids = id
      .toString()
      .split(",")
      .map((i) => i.trim());
    return ids.includes("216") || ids.includes("199");
  };

  const { notifySuccess, notifyError } = useNotification();

  const product = location.state?.product;
  const contact_details_id = location.state?.contact_details_id;

  const FetchProduct = async (id) => {
    // Show loading when calling get_product_details API
    console.log("FetchProduct: Setting loading states to true");
    
    // Use flushSync to force synchronous state update and immediate re-render
    // This is critical when FetchProduct is called from within other API responses
    try {
      flushSync(() => {
        setIsProductLoading(true);
        setIsLoading(true);
      });
    } catch (e) {
      // Fallback if flushSync is not available
      setIsProductLoading(true);
      setIsLoading(true);
    }
    
    console.log("FetchProduct called with id:", id);

    // Split product IDs if comma-separated
    const productIds = id.includes(",") ? id.split(",") : [id];
    console.log("Product IDs after splitting:", productIds);

    // Track start time to ensure minimum loading display time
    const startTime = Date.now();
    const minLoadingTime = 500; // Minimum 500ms to ensure loading is visible

    // Small delay to ensure the loading screen is rendered
    await new Promise(resolve => setTimeout(resolve, 100));

    try {
      // Fetch details for each product
      const productPromises = productIds.map(async (productId) => {
        console.log("Fetching product details for ID:", productId);
        const params = {
          product_id: productId.trim(),
        };

        const response = await axios.post(get_product_details, params);
        console.log("Product API response for", productId, ":", response.data);
        if (response.data.status == 1) {
          return response.data.product_data;
        } else {
          console.error(`Failed to fetch product ${productId}`);
          return null;
        }
      });

      // Wait for all product details to be fetched
      const productDetails = await Promise.all(productPromises);
      console.log("All product details:", productDetails);

      // Filter out null results and set state
      const validProducts = productDetails.filter(
        (product) => product !== null
      );
      console.log("Valid products:", validProducts);

      if (validProducts.length > 0) {
        setProducts(validProducts);
        setdata(validProducts[0]); // Set first product as main data

        // Store original product prices to prevent modification by m_price or coupons
        const priceMap = new Map();
        validProducts.forEach((product) => {
          if (product.product_id) {
            priceMap.set(product.product_id, parseFloat(product.product_price || 0));
          }
        });
        setOriginalProductPrices((prev) => {
          const newMap = new Map(prev);
          priceMap.forEach((price, id) => {
            // Only set if not already stored (preserve original prices)
            if (!newMap.has(id)) {
              newMap.set(id, price);
            }
          });
          return newMap;
        });

        // Calculate total price
        const totalPrice = validProducts.reduce((sum, product) => {
          return sum + parseFloat(product.product_price || 0);
        }, 0);
        setProductPrice(totalPrice.toString());

        console.log("Products fetched and set:", validProducts);
        console.log("Total price:", totalPrice);

        // Ensure minimum loading time before hiding loading screen
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime < minLoadingTime) {
          await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsedTime));
        }

        // Hide loading after successful fetch
        setIsProductLoading(false);
        setIsLoading(false);
        console.log("FetchProduct: Loading states set to false (success)");
        return validProducts; // Return products for chaining
      } else {
        setdata({});
        setProducts([]);
        setProductPrice("");
        console.log("No valid products found");
        
        // Ensure minimum loading time before hiding loading screen
        const elapsedTime = Date.now() - startTime;
        if (elapsedTime < minLoadingTime) {
          await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsedTime));
        }
        
        // Hide loading when no products found
        setIsProductLoading(false);
        setIsLoading(false);
        console.log("FetchProduct: Loading states set to false (no products)");
        navigate("/ErrorPage");
        return [];
      }
    } catch (err) {
      // Ensure minimum loading time before hiding loading screen
      const elapsedTime = Date.now() - startTime;
      if (elapsedTime < minLoadingTime) {
        await new Promise(resolve => setTimeout(resolve, minLoadingTime - elapsedTime));
      }
      
      // Hide loading on error
      setIsProductLoading(false);
      setIsLoading(false);
      console.log("FetchProduct: Loading states set to false (error)", err);
      return [];
    }
  };

  const FetchCdata = async (cdata) => {
    setIsLoading(true);
    await axios
      .post(get_url_data, {
        data: cdata,
      })
      .then((Response) => {
        setIsLoading(false);
        if (Response.data.status == 1) {
          setIsLoading(false);
          console.log("Response.data.decoded_data", Response.data.decoded_data);
          const data = Response.data.decoded_data;
          // console.log("data", data);

          setEmail(data?.email);
          setFirstName(data?.fname);
          setLastName(data?.lname);
          setPhoneNumber(data?.phone);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log("eeror------>", error);
      });
  };

  // Debug useEffect to track loading state changes
  useEffect(() => {
    console.log("isloading state changed:", isloading);
  }, [isloading]);

  useEffect(() => {
    console.log("isProductLoading state changed:", isProductLoading);
  }, [isProductLoading]);

  useEffect(() => {
    const currentUrl = window.location.href;

    // Parse the URL to extract query parameters
    const params = new URLSearchParams(new URL(currentUrl).search);

    // Get the 'uniqueId' parameter
    const id = params.get("uniqueId");
    const campionid = params.get("campaign_id");

    const cdata = params.get("cdata");

    console.log("campionid", campionid);
    console.log("cdata", cdata);
    // Set the extracted 'uniqueId' to state
    setUniqueId(id);
    setCampaignID(campionid);

    const urlParams = new URLSearchParams(window.location.search);
    const idValue = urlParams.get("id");
    const emailValue = urlParams.get("email");

    // Set the extracted ID and email in the state
    if (idValue) {
      setId(idValue);
    }
    if (emailValue) {
      setEmail(emailValue);
    }

    console.log("idValue", idValue);
    console.log("emailValue", emailValue);
    console.log(
      "URL format check - idValue type:",
      typeof idValue,
      "emailValue type:",
      typeof emailValue
    );

    // Fetch checkout link data and prefill form fields
    if (emailValue && idValue) {
      console.log("Both email and id present - calling get_checkout_link_data");
      // If both id and email are present, send both
      axios
        .post(get_checkout_link_data, { id: idValue, email: emailValue })
        .then((res) => {
          if (
            res.data.status === 1 &&
            res.data.data &&
            res.data.data.user_data
          ) {
            // Extract checkout_link_id if present
            if (res.data.data.checkout_link_id) {
              setCheckoutLinkId(res.data.data.checkout_link_id);
            }
            const user = res.data.data.user_data;
            setEmail(user.email || "");
            setUserData(user || "");
            setFirstName(user.first_name || "");
            setLastName(user.last_name || "");
            setPhoneNumber(user.phone || "");
            setAddress(user.address || "");
            setCity(user.city_name || "");
            setPostalCode(user.zip_code || "");
            // Set date of birth and gender if present
            if (user.date_of_birth) {
              setDateOfBirth(user.date_of_birth);
            }
            if (user.gender) {
              setGender(user.gender);
            }
            // Set shipping state if present
            if (user.state_name) {
              console.log(
                "Setting state from API (both email and id):",
                user.state_name
              );
              // Set pending state - the useEffect will handle it when states are loaded
              setPendingStateToSet(user.state_name);
            }
            // Set shipping cost, name, and id if present
            if (user.shipping_cost) {
              setShippingCost(user.shipping_cost);
            }
            if (user.new_shipping_cost) {
              setNewShippingCost(user.new_shipping_cost);
            }
            if (user.shipping_code) {
              setShippingCode(user.shipping_code);
            }
            if (user.shipping_name) {
              setShippingName(user.shipping_name);
            }
            if (user.shipping_id) {
              setShippingId(user.shipping_id);
            }
            if (user.new_shipping_id) {
              setNewShippingId(user.new_shipping_id);
            }
            // Map card_type string to dropdown value (adjusted as needed)
            let cardTypeValue = 1;
            if (user.card_type) {
              const type = user.card_type.toLowerCase();
              if (type === "visa") cardTypeValue = 1;
              else if (type === "mastercard") cardTypeValue = 2;
              else if (type === "discover") cardTypeValue = 3;
              else if (type === "american express" || type === "amex")
                cardTypeValue = 4;
            }
            setCardid(cardTypeValue);
            // setCardNumber(user.card_no || "");
            // setExMonth(user.ex_month || "");
            // setExYear(user.ex_year || "");
            // setExpiryDate(
            //   user.ex_month && user.ex_year
            //     ? `${user.ex_month}/${user.ex_year}`
            //     : ""
            // );
            // setCvv(user.cvv_no || "");
            // setcardholdername(user.card_holder_name || "");
            // Products and prices
            if (
              user.product_id &&
              Array.isArray(user.product_id) &&
              user.product_id.length > 0
            ) {
              // Store prices from API response
              const apiProductPrices = user.product_price || [];
              const apiOriginalPrices = user.original_price || [];
              if (apiProductPrices.length > 0) {
                setHasCheckoutLinkPrices(true);
              }

              console.log("Checkout link data prices:", {
                productPrices: apiProductPrices,
                originalPrices: apiOriginalPrices,
              });

              // Call FetchProduct to get detailed product information
              FetchProduct(user.product_id.join(","))
                .then(() => {
                  // After products are fetched, update prices from API response
                  if (apiProductPrices.length > 0) {
                    setProducts((prevProducts) => {
                      return prevProducts.map((product, index) => {
                        if (index < apiProductPrices.length) {
                          const productId = product.product_id;
                          const newPrice = parseFloat(apiProductPrices[index] || 0);
                          
                          // Store original price if not already stored
                          if (productId) {
                            setOriginalProductPrices((prev) => {
                              const newMap = new Map(prev);
                              if (!newMap.has(productId)) {
                                newMap.set(productId, newPrice);
                              }
                              return newMap;
                            });
                          }
                          
                          return {
                            ...product,
                            product_price: apiProductPrices[index],
                            original_price:
                              apiOriginalPrices[index] ||
                              apiProductPrices[index],
                          };
                        }
                        return product;
                      });
                    });

                    // Calculate total price using API prices
                    const totalPrice = apiProductPrices.reduce((sum, price) => {
                      return sum + parseFloat(price || 0);
                    }, 0);
                    setProductPrice(totalPrice.toString());
                    console.log("Updated prices from checkout link data:", {
                      productPrices: apiProductPrices,
                      originalPrices: apiOriginalPrices,
                      totalPrice: totalPrice,
                    });
                  }
                })
                .catch((err) => {
                  console.error("Error updating prices:", err);
                });
            }
            // Billing address (if present)
            if (user.billingSameAsShipping === "NO") {
              setSameAsShipping(false);
              // Set billing fields if you have them in your state
              setFirstName2(user.billingFirstName || "");
              setLastName2(user.billingLastName || "");
              setAddress2(user.billingAddress || "");
              setCity2(user.billingCity || "");
              setPostalCode2(user.billingZip || "");
              setPhoneNumber2(user.billingPhone || "");
              setSelectedState2({
                name: user.billingState || "",
                state_code: user.billingState || "",
              });
              setSelectedStateCode2({
                name: user.billingState || "",
                state_code: user.billingState || "",
              });
            } else {
              setSameAsShipping(true);
            }
          }
        })
        .catch((err) => {
          console.error("Failed to fetch checkout link data", err);
        });
    } else if (emailValue) {
      console.log(
        "Only email present - calling get_checkout_link_data with email only"
      );
      // If only email is present, send only email
      axios
        .post(get_checkout_link_data, { email: emailValue })
        .then((res) => {
          if (
            res.data.status === 1 &&
            res.data.data &&
            res.data.data.user_data
          ) {
            // Extract checkout_link_id if present
            if (res.data.data.checkout_link_id) {
              setCheckoutLinkId(res.data.data.checkout_link_id);
            }
            const user = res.data.data.user_data;
            setEmail(user.email || "");
            setFirstName(user.first_name || "");
            setLastName(user.last_name || "");
            setPhoneNumber(user.phone || "");
            setAddress(user.address || "");
            setCity(user.city_name || "");
            setPostalCode(user.zip_code || "");
            // Set date of birth and gender if present
            if (user.date_of_birth) {
              setDateOfBirth(user.date_of_birth);
            }
            if (user.gender) {
              setGender(user.gender);
            }
            // Set shipping state if present
            if (user.state_name) {
              console.log(
                "Setting state from API (email only):",
                user.state_name
              );
              // Set pending state - the useEffect will handle it when states are loaded
              setPendingStateToSet(user.state_name);
            }
            // Set shipping cost, name, and id if present
            if (user.shipping_cost) {
              setShippingCost(user.shipping_cost);
            }
            if (user.new_shipping_cost) {
              setNewShippingCost(user.new_shipping_cost);
            }
            if (user.shipping_code) {
              setShippingCode(user.shipping_code);
            }
            if (user.shipping_name) {
              setShippingName(user.shipping_name);
            }
            if (user.new_shipping_id) {
              setNewShippingId(user.new_shipping_id);
            }
            // Map card_type string to dropdown value (adjusted as needed)
            let cardTypeValue = 1;
            if (user.card_type) {
              const type = user.card_type.toLowerCase();
              if (type === "visa") cardTypeValue = 1;
              else if (type === "mastercard") cardTypeValue = 2;
              else if (type === "discover") cardTypeValue = 3;
              else if (type === "american express" || type === "amex")
                cardTypeValue = 4;
            }
            setCardid(cardTypeValue);
            // setCardNumber(user.card_no || "");
            // setExMonth(user.ex_month || "");
            // setExYear(user.ex_year || "");
            // setExpiryDate(
            //   user.ex_month && user.ex_year
            //     ? `${user.ex_month}/${user.ex_year}`
            //     : ""
            // );
            // setCvv(user.cvv_no || "");
            // setcardholdername(user.card_holder_name || "");
            // Products and prices
            if (
              user.product_id &&
              Array.isArray(user.product_id) &&
              user.product_id.length > 0
            ) {
              // Store prices from API response
              const apiProductPrices = user.product_price || [];
              const apiOriginalPrices = user.original_price || [];
              if (apiProductPrices.length > 0) {
                setHasCheckoutLinkPrices(true);
              }

              console.log("Checkout link data prices:", {
                productPrices: apiProductPrices,
                originalPrices: apiOriginalPrices,
              });

              // Call FetchProduct to get detailed product information
              FetchProduct(user.product_id.join(","))
                .then(() => {
                  // After products are fetched, update prices from API response
                  if (apiProductPrices.length > 0) {
                    setProducts((prevProducts) => {
                      return prevProducts.map((product, index) => {
                        if (index < apiProductPrices.length) {
                          const productId = product.product_id;
                          const newPrice = parseFloat(apiProductPrices[index] || 0);
                          
                          // Store original price if not already stored
                          if (productId) {
                            setOriginalProductPrices((prev) => {
                              const newMap = new Map(prev);
                              if (!newMap.has(productId)) {
                                newMap.set(productId, newPrice);
                              }
                              return newMap;
                            });
                          }
                          
                          return {
                            ...product,
                            product_price: apiProductPrices[index],
                            original_price:
                              apiOriginalPrices[index] ||
                              apiProductPrices[index],
                          };
                        }
                        return product;
                      });
                    });

                    // Calculate total price using API prices
                    const totalPrice = apiProductPrices.reduce((sum, price) => {
                      return sum + parseFloat(price || 0);
                    }, 0);
                    setProductPrice(totalPrice.toString());
                    console.log("Updated prices from checkout link data:", {
                      productPrices: apiProductPrices,
                      originalPrices: apiOriginalPrices,
                      totalPrice: totalPrice,
                    });
                  }
                })
                .catch((err) => {
                  console.error("Error updating prices:", err);
                });
            }
            // Billing address (if present)
            if (user.billingSameAsShipping === "NO") {
              setSameAsShipping(false);
              // Set billing fields if you have them in your state
              setFirstName2(user.billingFirstName || "");
              setLastName2(user.billingLastName || "");
              setAddress2(user.billingAddress || "");
              setCity2(user.billingCity || "");
              setPostalCode2(user.billingZip || "");
              setPhoneNumber2(user.billingPhone || "");
              setSelectedState2({
                name: user.billingState || "",
                state_code: user.billingState || "",
              });
              setSelectedStateCode2({
                name: user.billingState || "",
                state_code: user.billingState || "",
              });
            } else {
              setSameAsShipping(true);
            }
          }
        })
        .catch((err) => {
          console.error("Failed to fetch checkout link data", err);
        });
    } else if (idValue) {
      // If only id is present, call FetchProduct directly with the id
      console.log("Only ID present, calling FetchProduct with:", idValue);
      FetchProduct(idValue);
    }

    // Handle multiple product IDs if passed as comma-separated values
    const productIds = urlParams.get("product_ids");
    if (productIds) {
      // If product_ids parameter exists, use it instead of single id
      setId(productIds);
    }

    // set c data with api
    if (cdata) {
      FetchCdata(cdata);
    }

    // Set states from local JSON file
    setState(usStates);

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    console.log("location.state", location.state);
    console.log("idValue", idValue);
    // FetchProduct is now called from the API response, not here
    const currentDomain = window.location.hostname;
    console.log("12122", currentDomain);

    // Click Tracking Script
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.id = "pap_x2s6df8d";
    script1.src = "https://pharmazee.postaffiliatepro.com/scripts/5ogv666ehj";
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.type = "text/javascript";
      script2.innerHTML = `
        PostAffTracker.setAccountId('default1');
        window.CampaignID='14e7b018';
        try {
          PostAffTracker.track();
        } catch (err) { }
      `;
      document.head.appendChild(script2);
    };

    return () => {
      // Cleanup scripts when component unmounts
      const script1Element = document.getElementById("pap_x2s6df8d");
      if (script1Element) {
        script1Element.remove();
      }
    };
  }, []);

  const [getallCitys, setAllCitys] = useState([]);
  const [getselectedState, setSelectedState] = useState({
    name: "",
    state_code: "",
  });
  const [getselectedStateCode, setSelectedStateCode] = useState({
    name: "",
    state_code: "",
  });

  // google map start
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  var initializeAutocomplete = () => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.error("Google Maps API not available.");
      setIsLoading(false);
      return;
    }

    const parseAddressComponents = (place) => {
      let stateName = "";
      let stateCode = "";
      let city = "";
      let postalCode = "";

      if (place && place.address_components) {
        // Loop through address components to extract desired fields
        place.address_components.forEach((component) => {
          const types = component.types;
          if (types.includes("administrative_area_level_1")) {
            // State Name and Code
            stateName = component.long_name;
            stateCode = component.short_name; // Short name is usually the state code
          }
          if (types.includes("locality")) {
            // City
            city = component.long_name;
          }
          if (types.includes("postal_code")) {
            // Postal Code
            postalCode = component.long_name;
          }
        });
      }

      return { stateName, stateCode, city, postalCode };
    };

    const cleanAddress = (formattedAddress, componentsToRemove) => {
      // let cleanedAddress = formattedAddress;

      // componentsToRemove.forEach((component) => {
      //   if (component) {
      //     cleanedAddress = cleanedAddress
      //       .replace(component, "")
      //       .replace(/,\s*,/, ",")
      //       .trim();
      //   }
      // });

      // // Remove trailing commas and extra spaces
      // cleanedAddress = cleanedAddress
      //   .replace(/(^,)|(,$)/g, "")
      //   .replace(/\s{2,}/g, " ")
      //   .trim();

      // return cleanedAddress;

      // Split the address by commas and take only the first part
      const addressParts = formattedAddress.split(",");
      return addressParts[0].trim(); // Extracts only the first part (like "Tennessee")
    };

    // Initialize Autocomplete for the first input
    if (inputRef1.current) {
      const autocomplete1 = new window.google.maps.places.Autocomplete(
        inputRef1.current,
        {
          types: ["geocode"], // Restrict to address-type predictions
          componentRestrictions: { country: "us" },
        }
      );

      autocomplete1.addListener("place_changed", () => {
        const place = autocomplete1.getPlace();
        console.log("Place details (input 1):", place);

        if (place) {
          const { stateName, stateCode, city, postalCode } =
            parseAddressComponents(place);

          const cleanedAddress = cleanAddress(place.formatted_address, [
            city,
            stateName,
            postalCode,
          ]);

          console.log("stateName", stateName);
          console.log("stateCode", stateCode);
          console.log("postalCode", postalCode);
          console.log("city-->sZ", city);

          if (stateName && stateCode) {
            setSelectedState({ name: stateName, state_code: stateCode });
            setSelectedStateCode({ name: stateName, state_code: stateCode });
            // AllCitys(stateName);
          }

          if (city) {
            console.log("city---->", city);
            setCity(city); // Assuming you still need city
            setPostalCode("");
          }

          if (postalCode) {
            setPostalCode(postalCode); // Assuming you still need postal code
          }

          setAddress(cleanedAddress); // Set full address
          // setAddress(place.formatted_address); // Set full address
        }
      });
    }

    // Initialize Autocomplete for the second input
    if (inputRef2.current) {
      const autocomplete2 = new window.google.maps.places.Autocomplete(
        inputRef2.current,
        {
          types: ["geocode"], // Restrict to address-type predictions
          componentRestrictions: { country: "us" },
        }
      );

      autocomplete2.addListener("place_changed", () => {
        const place = autocomplete2.getPlace();
        console.log("Place details (input 2):", place);

        if (place) {
          const { stateName, stateCode, city, postalCode } =
            parseAddressComponents(place);

          const cleanedAddress = cleanAddress(place.formatted_address, [
            city,
            stateName,
            postalCode,
          ]);

          if (stateName && stateCode) {
            setSelectedState2({ name: stateName, state_code: stateCode });
            setSelectedStateCode2({ name: stateName, state_code: stateCode });
            // AllCitys(stateName);
          }

          if (city) {
            setCity2(city); // Assuming you need city for second input
            setPostalCode2("");
          }

          if (postalCode) {
            setPostalCode2(postalCode); // Assuming you need postal code for second input
          }

          // setAddress2(place.formatted_address); // Set full address for second input
          setAddress2(cleanedAddress);
        }
      });
    }

    setIsLoading(false);
  };

  // use Effects for checking gmap

  useEffect(() => {
    if (!getsection2 && inputRef1.current) {
      initializeAutocomplete();
    }
  }, [getsection2, inputRef1]);
  useEffect(() => {
    if (getsection2 && inputRef2.current) {
      initializeAutocomplete();
    }
  }, [getsection2, inputRef2]);
  useEffect(() => {
    if (!sameAsShipping && inputRef2.current) {
      initializeAutocomplete();
    }
  }, [sameAsShipping, inputRef2]);
  useEffect(() => {
    if (!isloading && inputRef2.current) {
      initializeAutocomplete();
    }
  }, [isloading, inputRef2]);
  useEffect(() => {
    if (!isloading && inputRef1.current) {
      initializeAutocomplete();
    }
  }, [isloading, inputRef1]);

  useEffect(() => {
    console.log("Updated state code:", getselectedStateCode);
  }, [getselectedStateCode]);

  // Handle pending state prefill when states are loaded
  useEffect(() => {
    if (pendingStateToSet && getstate.length > 0) {
      console.log("Setting pending state:", pendingStateToSet);
      const matchingState = getstate.find(
        (state) =>
          state.state_code === pendingStateToSet ||
          state.name === pendingStateToSet
      );

      if (matchingState) {
        console.log("Found matching state:", matchingState);
        setSelectedState({
          name: matchingState.name,
          state_code: matchingState.state_code,
        });
        setSelectedStateCode({
          name: matchingState.name,
          state_code: matchingState.state_code,
        });
        handleStateChange(matchingState.name);
      } else {
        // Fallback if state not found
        console.log("State not found in list, using fallback");
        setSelectedState({
          name: pendingStateToSet,
          state_code: pendingStateToSet,
        });
        setSelectedStateCode({
          name: pendingStateToSet,
          state_code: pendingStateToSet,
        });
      }
      // Clear pending state
      setPendingStateToSet(null);
    }
  }, [pendingStateToSet, getstate]);

  useEffect(() => {
    const loadScript = (url, callback) => {
      const existingScript = document.querySelector(`script[src="${url}"]`);

      if (!existingScript) {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = callback;
        script.onerror = () => {
          console.error("Google Maps script failed to load.");
          setIsLoading(false);
        };
        document.body.appendChild(script);
      } else {
        callback();
      }
    };

    // Load Google Maps API script
    loadScript(
      `https://maps.googleapis.com/maps/api/js?key=AIzaSyDqypMXRxstlMdPZ-LUGWb4w36I0ENsu9U&libraries=places`,
      initializeAutocomplete
    );
  }, []);
  // google map end

  const handleStateChange = async (value) => {
    // setIsLoading(true);
    var params = {
      state_name: value,
    };
    await axios
      .post(cheke_state, params)
      .then((res) => {
        // setIsLoading(false);
        const data = res.data;
        if (data.status === 0) {
          setSelectedState({
            name: "",
            state_code: "",
          });
          setSelectedStateCode({
            name: "",
            state_code: "",
          });
          // setAllCitys([]);
          setCity("");
          notifyError(data.message);
        }
        // else {
        //   AllCitys(value);
        // }
      })
      .catch((err) => {
        console.log("err", err);
        // setIsLoading(false);
      });
  };

  const handleStateChange2 = async (value) => {
    // setIsLoading(true);
    var params = {
      state_name: value,
    };
    await axios
      .post(cheke_state, params)
      .then((res) => {
        // setIsLoading(false);
        const data = res.data;
        if (data.status === 0) {
          setSelectedState2({
            name: "",
            state_code: "",
          });
          setSelectedStateCode2({
            name: "",
            state_code: "",
          });
          // setAllCitys([]);
          setCity2("");
          notifyError(data.message);
        }
        // else {
        //   AllCitys(value);
        // }
      })
      .catch((err) => {
        console.log("err", err);
        // setIsLoading(false);
      });
  };

  const AllCitys = async (state) => {
    setIsCityLoading(true);
    await axios
      .post("https://countriesnow.space/api/v0.1/countries/state/cities", {
        country: "United States",
        state: state,
      })
      .then((res) => {
        setIsCityLoading(false);
        const data = res.data.data;
        console.log("citys", res.data.data);
        setAllCitys(data);
      })
      .catch((err) => {
        console.log("err", err);
        setIsCityLoading(false);
      });
  };

  // page 1 validation

  const Page1Validate = () => {
    if (email === "" || email === null) {
      notifyError("Please enter Email Address.");
      return;
    } else if (!validateEmail(email)) {
      notifyError("Please enter a valid Email Address.");
      return;
    } else if (firstName === "" || firstName === null) {
      notifyError("Please enter First Name.");
      return;
    } else if (lastName === "" || lastName === null) {
      notifyError("Please enter Last Name.");
      return;
    } else if (address === "" || address === null) {
      notifyError("Please enter Address.");
      return;
      // } else if (address.length > 34) {
      //   notifyError("Address cannot exceed 34 characters.");
      //   return;
    } else if (
      getselectedStateCode.name === "" ||
      getselectedStateCode.name === null
    ) {
      notifyError("Please select State.");
      return;
    } else if (city === "" || city === null) {
      notifyError("Please select City.");
      return;
      // } else if (getallCitys.includes(city) == false) {
      //   notifyError("Please select City.");
      //   return;
    } else if (postalCode === "" || postalCode === null) {
      notifyError("Please enter Postal Code.");
      return;
    } else if (phoneNumber === "" || phoneNumber === null) {
      notifyError("Please enter Phone Number.");
      return;
    } else if (phoneNumber.length < 10) {
      notifyError("Please enter valid Phone Number.");
      return;
    } else if (
      requiresDOBAndGender() &&
      (dateOfBirth === "" || dateOfBirth === null)
    ) {
      notifyError("Please enter Date of Birth.");
      return;
    } else if (requiresDOBAndGender() && (gender === "" || gender === null)) {
      notifyError("Please select Gender.");
      return;
    } else {
      setSection2(true);
    }
  };

  // page 2 validations

  const Page2Validate = () => {
    if (cardNumber === "" || cardNumber === null) {
      notifyError("Please enter Card Number.");
      return;
    } else if (cardNumber.length < 15 || cardNumber.length > 16) {
      notifyError("Please enter valid Card Number.");
      return;
    } else if (cardholdername === "" || cardholdername === null) {
      notifyError("Please enter Name on Card.");
      return;
    } else if (expiryDate === "" || expiryDate === null) {
      notifyError("Please enter Expiry Date.");
      return;
    } else {
      // Split the expiry date into month and year
      const [month, year] = expiryDate.split("/");

      // Check if the month and year are valid
      if (!month || !year || month.length !== 2 || year.length !== 2) {
        notifyError(
          "Invalid format. Please enter the expiry date in MM/YY format."
        );
        return;
      }

      // Check if the month is valid (between 01 and 12)
      if (parseInt(month, 10) < 1 || parseInt(month, 10) > 12) {
        notifyError("Invalid month. Please enter a valid month (01-12).");
        return;
      }

      // Check if the year is valid (current year or future year)
      const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of current year
      if (parseInt(year, 10) < currentYear) {
        notifyError("Invalid year. Please enter a valid future year.");
        return;
      }
    }
    if (cvv === "" || cvv === null) {
      notifyError("Please enter Security code.");
      return;
    } else if (cvv.length < 3) {
      notifyError("Please enter valid Security code.");
      return;
    } else if (!sameAsShipping && (firstName2 === "" || firstName2 === null)) {
      notifyError("Please enter First Name.");
      return;
    } else if (!sameAsShipping && (lastName2 === "" || lastName2 === null)) {
      notifyError("Please enter Last Name.");
      return;
    } else if (!sameAsShipping && (address2 === "" || address2 === null)) {
      notifyError("Please enter Address.");
      return;
      // } else if (!sameAsShipping && address2.length > 34) {
      //   notifyError("Address cannot exceed 34 characters.");
      //   return;
    } else if (
      !sameAsShipping &&
      (getselectedStateCode2.name === "" || getselectedStateCode2.name === null)
    ) {
      notifyError("Please select State.");
      return;
    } else if (!sameAsShipping && (city2 === "" || city2 === null)) {
      notifyError("Please select City.");
      return;
      // } else if (!sameAsShipping && getallCitys.includes(city2) == false) {
      //   notifyError("Please select City.");
      //   return;
    } else if (
      !sameAsShipping &&
      (postalCode2 === "" || postalCode2 === null)
    ) {
      notifyError("Please enter Postal Code.");
      return;
    } else if (
      !sameAsShipping &&
      (phoneNumber2 === "" || phoneNumber2 === null)
    ) {
      notifyError("Please enter Phone Number.");
      return;
    } else if (!sameAsShipping && phoneNumber2.length < 10) {
      notifyError("Please enter valid Phone Number.");
      return;
    } else {
      checkout_api();
      // console.log("done");
    }
  };

  const checkout_api = async () => {
    setIsLoading(true);

    // Group products by product_id and count quantities
    const productMap = new Map();

    getproducts.forEach((product) => {
      const productId = product.product_id;
      if (productMap.has(productId)) {
        // Increment quantity if product already exists
        const existing = productMap.get(productId);
        existing.quantity = (existing.quantity || 1) + 1;
      } else {
        // Add new product with quantity 1
        productMap.set(productId, {
          product_id: productId,
          product_price: product.product_price,
          original_price: product.original_price || product.product_price,
          gateway_id: "1", // Default gateway_id
          billing_model_id: "3", // Default billing_model_id
          promoCode: "0", // Default promoCodes
          quantity: 1,
        });
      }
    });

    // Convert map to arrays for unique products
    const uniqueProducts = Array.from(productMap.values());
    const productIds = uniqueProducts.map((product) => product.product_id);
    const productPrices = uniqueProducts.map(
      (product) => product.product_price
    );
    const originalPrices = uniqueProducts.map(
      (product) => product.original_price
    );
    const gatewayIds = uniqueProducts.map((product) => product.gateway_id);
    const billingModelIds = uniqueProducts.map(
      (product) => product.billing_model_id
    );
    const promoCodes = uniqueProducts.map((product) => product.promoCode);
    const quantities = uniqueProducts.map((product) =>
      product.quantity.toString()
    );

    console.log("Unique Product IDs before sending:", productIds);
    console.log("Product Prices before sending:", productPrices);
    console.log("Quantities:", quantities);

    // Validate product IDs
    if (!productIds || productIds.length === 0) {
      notifyError("No products found. Please try again.");
      setIsLoading(false);
      return;
    }

    // Check for empty product IDs
    const invalidProductIds = productIds.filter((id) => !id || id === "");
    if (invalidProductIds.length > 0) {
      notifyError("Invalid product data. Please refresh and try again.");
      setIsLoading(false);
      return;
    }

    // Create FormData for proper array handling
    const formData = new FormData();

    // Add basic parameters
    formData.append("billingSameAsShipping", sameAsShipping ? "YES" : "NO");
    formData.append("email", email);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("phone", phoneNumber);
    formData.append("address", address);
    formData.append("city_name", city);
    formData.append("state_name", getselectedStateCode.state_code);
    formData.append("zip_code", postalCode);
    formData.append(
      "card_type",
      getcardid === 1
        ? "visa"
        : getcardid === 2
        ? "mastercard"
        : getcardid === 3
        ? "discover"
        : "american express"
    );
    formData.append("card_no", cardNumber);
    formData.append("ex_month", exMonth);
    formData.append("ex_year", exYear);
    formData.append("cvv_no", cvv);
    formData.append("card_holder_name", cardholdername);
    formData.append("start_url", window.location.href);
    formData.append("contact_details_id", contact_details_id);
    formData.append("promo_codes", appliedDiscount);
    formData.append("campaign_id", getcampaignID);

    // Add checkout_link_id if available
    if (checkoutLinkId !== null && checkoutLinkId !== undefined) {
      formData.append("checkout_link_id", checkoutLinkId);
    }

    // Add shipping information if available
    if (shippingId !== null && shippingId !== undefined) {
      formData.append("shipping_id", shippingId);
    }
    if (newShippingId !== null && newShippingId !== undefined) {
      formData.append("new_shipping_id", newShippingId);
    }
    if (newshippingCost && parseFloat(newshippingCost) > 0) {
      formData.append("shipping_cost", newshippingCost);
    }
    if (shippingCode) {
      formData.append("shipping_code", shippingCode);
    }

    // Add date of birth and gender for specific products
    if (requiresDOBAndGender()) {
      formData.append("date_of_birth", dateOfBirth);
      formData.append("gender", gender);
    }

    // Add billing address fields if different from shipping
    if (!sameAsShipping) {
      formData.append("billingFirstName", firstName2);
      formData.append("billingLastName", lastName2);
      formData.append("billingAddress", address2);
      formData.append("billingCity", city2);
      formData.append("billingState", getselectedStateCode2.state_code);
      formData.append("billingZip", postalCode2);
      formData.append("billingCountry", "US");
    }

    // Add product arrays with proper array notation (only unique products with quantities)
    productIds.forEach((productId, index) => {
      formData.append("product_id[]", productId);
      formData.append("product_price[]", productPrices[index]);
      formData.append("original_price[]", originalPrices[index]);
      formData.append("gateway_id[]", gatewayIds[index]);
      formData.append("billing_model_id[]", billingModelIds[index]);
      formData.append("promoCodes[]", promoCodes[index]);
      formData.append("qty[]", quantities[index]);
    });

    console.log("FormData entries:");
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    try {
      const Response = await axios.post(createOrder_test, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("API Response:", Response);
      console.log("Response Status:", Response.status);
      console.log("Response Data:", Response.data);

      setIsLoading(false);

      // Handle both single order and array of orders response
      let orders = [];
      if (Array.isArray(Response.data)) {
        // New format: array of orders
        orders = Response.data.filter((order) => order.status === 1);
      } else if (Response.data.status === 1) {
        // Old format: single order
        orders = [Response.data];
      }

      if (orders.length > 0) {
        setIsLoading(false);
        console.log("Order(s) created successfully:", orders);

        // Use the first order for tracking and navigation
        const firstOrder = orders[0];

        // google tag pixel //
        window.gtag &&
          window.gtag("event", "conversion", {
            send_to: "AW-11515103107", // Replace with your conversion label
            value: calculateTotal().toFixed(2),
            currency: "USD",
            transaction_id: firstOrder.order_id, // Use first order ID
          });
        // google tag pixel //
        // navigate("/SuccessPage");
        // setSkipModel(true);
        setorder_id(firstOrder.order_id);

        navigate("/thankyou-page", {
          state: {
            email: email,
            phoneNumber: phoneNumber,
            orderId: firstOrder.order_id, // Use first order ID
            firstName: firstName,
            lastName: lastName,
            stateName: getselectedStateCode.name,
            stateCode: getselectedStateCode.state_code,
            productTotal: calculateTotal().toFixed(2),
            productId: getproducts[0].product_id,
            // Add all order IDs for reference
            allOrderIds: orders.map((order) => order.order_id),
          },
        });

        // facebook pixel start
        if (window.fbq) {
          window.fbq("track", "Purchase", {
            value: calculateTotal().toFixed(2),
            currency: "USD",
          });
        }
        // facebook pixel end
        // setThankyouURL(`https://go.pharmazee.co/thankyou/?order_id=${firstOrder.order_id}`)
      } else if (Array.isArray(Response.data) && Response.data.length > 0) {
        // Handle array response with errors
        const failedOrders = Response.data.filter(
          (order) => order.status !== 1
        );
        if (failedOrders.length > 0) {
          console.log("Some orders failed:", failedOrders);
          notifyError(failedOrders[0].message || "Order creation failed");
        }
      } else if (Response.data.status == 5) {
        console.log("Payment update required:", Response.data);
        notifyError(Response.data.message);
        // navigate(`/UpdatePayment/${Response.data.order_id}`);
      } else if (Response.data.error_details) {
        console.log("API Error details:", Response.data.error_details);
        notifyError(Response.data.error_details.message);
      } else {
        console.log("API Error:", Response.data);
        setIsLoading(false);
        notifyError(Response.data.message || "Order creation failed");
      }
      console.log("====================================");
      console.log("createOrder_test res =>", Response.data);
      console.log("====================================");
    } catch (error) {
      console.log("API Call Error:", error);
      console.log("Error Response:", error.response);
      console.log("Error Message:", error.message);
      setIsLoading(false);
      notifyError("Failed to create order. Please try again.");
    }
  };

  const handleCardChange = (event) => {
    const cardValue = parseInt(event.target.value);
    setCardid(cardValue);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Only set the CVV if the length is 3 or less and it's numeric
    if (value.length <= 4 && /^\d*$/.test(value)) {
      setCvv(value);
    }
  };

  const formatCardNumber = (cardNumber) => {
    // Add spaces every 4 characters
    return cardNumber.replace(/\D/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
  };

  const [validEmail, setValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const input = e.target.value;
    setEmail(input);

    // Basic email validation regex
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = emailRegex.test(input);

    setValidEmail(isValid);
  };

  const productChange = (id) => {
    console.log("e.targate.value", id);
    navigate(`/${id}`);
    // FetchProduct is now called from the API response, not here
  };

  const [countdown, setCountdown] = useState(3); // Timer for 3 seconds

  // useEffect for close modal after 3 secound
  useEffect(() => {
    if (getskipModel) {
      console.log("getdata?.offer_id", getdata?.offer_id);

      let timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);

      // const timer = setTimeout(() => {
      //   setSkipModel(false);
      //   window.location.assign(targetUrl);
      // }, 3000); // Delay to ensure the script has loaded

      const redirectTimer = setTimeout(() => {
        setSkipModel(false);
        window.location.assign(memberPortalUrl);
      }, 3000);

      return () => {
        clearInterval(timer);
        clearTimeout(redirectTimer);
      };
    }
  }, [getskipModel]);

  // memberportel redire url
  const currentDomain = window.location.hostname;

  let memberPortalUrl = "https://member.pharmazee.co/"; // Default URL

  if (currentDomain === "checkout.pharmazee.co") {
    memberPortalUrl = "https://member.pharmazee.co/";
  } else if (currentDomain === "checkoutdev-pharmazee.wlmd.dev") {
    memberPortalUrl = "https://member.pharmazee.co/";
  }

  console.log("currentDomain", currentDomain);
  console.log("memberPortalUrl", memberPortalUrl);

  // const targetUrl = getdata.is_intake === "0"
  //   ? `https://pharmazee.co/weight-loss-order-first/?order_id=${getorder_id}&unique_id=${uniqueId}&op=intake`
  //   : memberPortalUrl;
  const targetUrl = memberPortalUrl;

  // after email api

  const handleEmailBlur = async () => {
    if (validEmail && email.trim() !== "") {
      setIsEmailLoading(true); // Start loading only if email is valid

      try {
        // Use the first product ID for member view API (or you might need to modify this API to handle multiple products)
        const firstProductId =
          getproducts.length > 0 ? getproducts[0].product_id : id;

        const response = await axios.post(member_view, {
          email: email,
          product_id: firstProductId,
          campaign_id: getcampaignID,
        });
        console.log("API Response:", response.data);
        if (response.data.status === 1) {
          // Store m_price but don't let it affect base price calculations for coupons
          // m_price is only used as a fallback when no products are available
          // This prevents m_price from interfering with coupon discount calculations
          // IMPORTANT: m_price should NEVER be used when calculating discounts for orders with products
          const mPrice = response.data?.m_price;
          if (mPrice && !hasCheckoutLinkPrices) {
            setProductPrice(mPrice);
            const parsedMPrice = parseFloat(mPrice);

            // Apply m_price to the active product flow when checkout-link prices are not present.
            // This ensures UI totals and product line-items show member_view price.
            if (!isNaN(parsedMPrice) && parsedMPrice > 0) {
              setdata((prev) => ({
                ...prev,
                product_price: mPrice,
                original_price: mPrice,
              }));

              setProducts((prevProducts) => {
                if (!Array.isArray(prevProducts) || prevProducts.length === 0) {
                  return prevProducts;
                }

                return prevProducts.map((product) => {
                  const productId = product?.product_id?.toString();
                  const targetProductId = firstProductId?.toString();
                  if (productId && targetProductId && productId === targetProductId) {
                    return {
                      ...product,
                      product_price: mPrice,
                      original_price: mPrice,
                    };
                  }
                  return product;
                });
              });

              if (firstProductId) {
                setOriginalProductPrices((prev) => {
                  const newMap = new Map(prev);
                  newMap.set(firstProductId, parsedMPrice);
                  return newMap;
                });
              }
            }
          }
        }
      } catch (error) {
        console.error("Error sending email:", error);
      } finally {
        setIsEmailLoading(false); // Ensure loading state resets even if API fails
      }
    }
  };

  // Show loading screen when either main loading or product loading is active
  if (isloading || isProductLoading) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#ffffff",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
          padding: "20px",
        }}
      >
        {/* Logo */}
        <div
          style={{
            marginBottom: "40px",
            opacity: 0.9,
          }}
        >
          <img
            src={images.logo}
            alt="Logo"
            style={{
              maxWidth: "180px",
              height: "auto",
              display: "block",
            }}
          />
        </div>

        {/* Loading Spinner */}
        <div
          className="loading-spinner"
          style={{
            width: "60px",
            height: "60px",
            border: "5px solid #f0f0f0",
            borderTop: "5px solid var(--clr-main, #2f8185)",
            borderRadius: "50%",
            marginBottom: "24px",
          }}
        />

        {/* Loading Text */}
        <p
          style={{
            fontSize: "16px",
            color: "#666",
            fontWeight: "400",
            margin: 0,
            letterSpacing: "0.3px",
          }}
        >
          {isProductLoading ? "Loading products..." : ""}
        </p>

        {/* Subtle loading dots animation */}
        <div
          style={{
            display: "flex",
            gap: "6px",
            marginTop: "16px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "var(--clr-main, #2f8185)",
              opacity: 0.6,
              animation: "pulse 1.4s ease-in-out infinite",
            }}
          />
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "var(--clr-main, #2f8185)",
              opacity: 0.6,
              animation: "pulse 1.4s ease-in-out infinite 0.2s",
            }}
          />
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "var(--clr-main, #2f8185)",
              opacity: 0.6,
              animation: "pulse 1.4s ease-in-out infinite 0.4s",
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* <Navbar2 color="#fff" logo={images.logo} /> */}
      <div className="payment-container" style={{ position: "relative" }}>
        {/* <div className="payment-content">
          <div className="payment-header_p">
            <p className="paymen_p_tag">Checkout</p>
          </div>
        </div> */}
        <div className="payment-content2 payment-column-reverse">
          {/* onSubmit={handleSubmit} */}
          <div className="checkout-form-wrapp">
            <div className="checkout_logo_wrapp headline_for_mob2">
              <img
                src={images.logo}
                className="my_logo"
                alt=""
                style={{ marginBottom: "20px" }}
              />

              <div className="checkout_head_name_wrapp">
                <p>Shipping</p>
                <FiChevronRight size={20} style={{ display: "block" }} />
                <p>Payment</p>
              </div>
            </div>

            {!getsection2 ? (
              <div className="checkout-form">
                {/* contect info */}
                <h3>Contact</h3>
                <div className="form-group">
                  <input
                    type="email"
                    placeholder={
                      isemailLoading ? "Verifying..." : "Email Address"
                    }
                    value={email}
                    onChange={handleEmailChange}
                    onBlur={handleEmailBlur} // Call API when moving away
                    style={{
                      border: validEmail ? "" : "1px solid red",
                      // backgroundColor: isemailLoading ? "#f5f5f5" : "white", // Light gray when verifying
                      // color: isemailLoading ? "#888" : "black",
                      cursor: isemailLoading ? "not-allowed" : "text",
                    }}
                    disabled={isemailLoading}
                  />
                  {isemailLoading && (
                    <p style={{ color: "blue", fontSize: "12px" }}>
                      Verifying...
                    </p>
                  )}
                  {!validEmail && (
                    <p style={{ color: "red", marginTop: "2px" }}>
                      Please enter a valid email address.
                    </p>
                  )}
                </div>
                <h3>Shipping Address</h3>
                {/* <div className="form-group"> */}
                <select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                >
                  <option>United States</option>
                  {/* Add more country options here */}
                </select>
                {/* </div> */}
                <div className="form-group-inline">
                  <div className="form-group min-width-50">
                    <input
                      type="text"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                  <div className="form-group min-width-50">
                    <input
                      type="text"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <input
                    ref={inputRef1}
                    type="text"
                    placeholder="Address"
                    value={address}
                    // onChange={(e) => setAddress(e.target.value)}
                    onChange={(e) => {
                      if (e.target.value.length == 0) {
                        setSelectedState({
                          name: "",
                          state_code: "",
                        });
                        setSelectedStateCode({
                          name: "",
                          state_code: "",
                        });
                        setCity("");
                        setPostalCode("");
                      }
                      setAddress(e.target.value);
                    }}
                  />
                </div>
                <div className="form-group-inline">
                  <div className="inline_seond">
                    <select
                      value={JSON.stringify({
                        name: getselectedState.name,
                        state_code: getselectedState.state_code,
                      })}
                      onChange={(e) => {
                        const selectedState = JSON.parse(e.target.value);

                        console.log("getselectedStateCode1", selectedState);

                        setSelectedState({
                          name: selectedState.name,
                          state_code: selectedState.state_code,
                        });
                        setSelectedStateCode({
                          name: selectedState.name,
                          state_code: selectedState.state_code,
                        });
                        // setSelectedStateCode(selectedState.state_code);
                        handleStateChange(selectedState.name); // Optional: If you have additional logic
                        console.log(
                          "getselectedStateCode",
                          selectedState.state_code
                        );
                      }}
                    >
                      <option
                        value={JSON.stringify({ name: "", state_code: "" })}
                      >
                        Select state
                      </option>
                      {getstate.map((state) => (
                        <option
                          key={state.state_code}
                          value={JSON.stringify({
                            name: state.name,
                            state_code: state.state_code,
                          })}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="inline_seond">
                    {iscityloading ? (
                      <div
                        style={{
                          marginTop: "10px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "3px solid #e0e0e0",
                            borderTop: "3px solid #f39322",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        ></div>
                      </div>
                    ) : (
                      // <select
                      //   value={city} // Use city directly
                      //   onChange={(e) => {
                      //     setCity(e.target.value);
                      //     setPostalCode("");
                      //   }} // Update city state on selection
                      //   disabled={iscityloading}
                      // >
                      //   <option value="">Select city</option>
                      //   {getallCitys.map((city, index) => (
                      //     <option key={index} value={city}>
                      //       {city}
                      //     </option>
                      //   ))}
                      // </select>
                      <div className="form-group" style={{ width: "100%" }}>
                        <input
                          type="text"
                          placeholder="City"
                          value={city}
                          // onChange={(e) => setFirstName(e.target.value)}
                          onChange={(e) => {
                            setCity(e.target.value);
                            setPostalCode("");
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Postal Code"
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                  </div>
                </div>
                {/* <br /> */}
                {/* phone number start */}
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Phone number"
                    value={phoneNumber}
                    onChange={(e) => {
                      const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      if (input.length <= 10) {
                        setPhoneNumber(input);
                      }
                    }}
                  />
                </div>
                {/* phone number end */}
                {/* <p>All transactions are secure and encrypted.</p> */}
                <br />

                {/* Date of birth and gender for specific products */}
                {requiresDOBAndGender() && (
                  <>
                    <div className="form-group">
                      <input
                        type="date"
                        placeholder="Date of Birth"
                        value={dateOfBirth}
                        onChange={(e) => setDateOfBirth(e.target.value)}
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                    <div className="form-group">
                      <select
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option value="">Select Gender</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                      </select>
                    </div>
                    <br />
                  </>
                )}

                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <input
                    type="checkbox"
                    id="medicationConsent"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    style={{
                      marginTop: "0px",
                      marginRight: "10px",
                      width: "25px",
                      height: "25px",
                      padding: "5px",
                      cursor: "pointer",
                      appearance: "auto",
                      accentColor: "var(--clr-main)",
                    }}
                    // className="details_of_checkbox"
                  />
                  <label
                    htmlFor="medicationConsent"
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.5",
                      fontWeight: "300",
                    }}
                  >
                    <strong style={{ fontWeight: "500" }}>
                      Text me when my medication ships
                    </strong>{" "}
                    and for exclusive health and weight loss content. I agree to
                    receive marketing text messages from pharmazee at the number
                    provided above. Consent is not a condition of purchase.
                    Message & data rates may apply.
                  </label>
                </div>

                {/* Submit btn start */}
                <br />
                {/* Submit btn end */}
                {/* promo code start*/}
                {/* <div className="payment_card">
              <div className="payment_card_titel">
                <b>
                  <RiDiscountPercentLine />
                  Promo Code
                </b>
              </div>

              <div className="form-group-inline">
                <div
                  className="inline_seond promo_input"
                >
                  <input
                    type="text"
                    value={discountCode}
                    onChange={(e) => setDiscountCode(e.target.value)}
                    placeholder="Enter Promo Code"
                  />
                </div>
                <div
                  className="inline_seond"
                  style={{ width: "30%", minWidth: "100px" }}
                >
                  <button className="btn" onClick={handleApplyDiscount}>
                    Apply
                  </button>
                </div>
              </div>
            </div> */}
                {/* Display error message */}

                {/* promo code end */}
                <br />
                {/* <br /> */}
                {/* payment details */}
                {/* <div className="payment_card">
              <div className="payment_card_titel">
                <b>
                  <MdOutlinePayment />
                  Payment Methods
                </b>
                <div className="card_icon_div">
                  <img
                    src={images.visa}
                    className="item_img_card"
                    alt="Headphones"
                  />
                  <img
                    src={images.master}
                    className="item_img_card"
                    alt="Headphones"
                  />
                  <img
                    src={images.jcb}
                    className="item_img_card"
                    alt="Headphones"
                  />
                  <img
                    src={images.american}
                    className="item_img_card"
                    alt="Headphones"
                  />
                </div>
              </div>
              <div className="details-card">
                <div className="form-group">
                  <select
                    className="card-dropdown"
                    onChange={handleCardChange}
                    value={getcardid}
                  >
                    <option value={1}>Visa</option>
                    <option value={2}>MasterCard</option>
                    <option value={3}>Discover</option>
                    <option value={4}>American Express</option>
                  </select>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Card holder name"
                    className="card-number"
                    value={cardholdername}
                    onChange={(e) => setcardholdername(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Card Number"
                    className="card-number"
                    value={formatCardNumber(cardNumber)}
                    onChange={(e) => {
                      const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      if (input.length <= 16) {
                        setCardNumber(input);
                      }
                    }}
                  />
                </div>
                <div className="form-group-inline">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="MM/YY"
                      className="expiry-date"
                      value={expiryDate}
                      onChange={(e) => {
                        let input = e.target.value;
                        // Remove non-numeric characters except "/"
                        input = input.replace(/\D/g, "");

                        // Ensure input is limited to 4 characters (MMYY format)
                        if (input.length > 4) {
                          input = input.slice(0, 4);
                        }

                        // Extract MM and YY
                        const month = input.slice(0, 2);
                        const year = input.slice(2, 4);

                        // Update state for ex_month and ex_year
                        setExMonth(month);
                        setExYear(year);

                        // Format input to display MM/YY in the input field
                        setExpiryDate(
                          month + (year.length > 0 ? "/" + year : "")
                        );
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="CVV"
                      className="cvv"
                      value={cvv}
                      onChange={handleChange}
                      maxLength={3}
                    />
                  </div>
                </div>
                <div className="note_titel_">
                
                </div>
                <center>
                  <button className="btn-checkout" onClick={checkout_api}>
                    Complete Checkout
                  </button>
                </center>
              </div>
            </div> */}
                <button
                  className="apply-button"
                  style={{ width: "100%" }}
                  onClick={Page1Validate}
                >
                  CONTINUE TO PAYMENT
                </button>
              </div>
            ) : (
              <div className="checkout-form">
                {/* contect box start */}
                <div className="sec2_checkout_box_wrapp">
                  <div>
                    <p>Contact</p>
                    <p>{email}</p>
                    <button
                      onClick={() => {
                        setSection2(false);
                      }}
                    >
                      Change
                    </button>
                  </div>
                  <div style={{ borderBottom: "none" }}>
                    <p>Ship to</p>
                    <p>{address}</p>
                    <button
                      onClick={() => {
                        setSection2(false);
                      }}
                    >
                      Change
                    </button>
                  </div>
                  {/* <div style={{borderBottom:"none"}}>
                    <p>Shipping method</p>
                    <p>Standard</p>
                    <button
                      onClick={() => {
                        setSection2(false);
                      }}
                    >
                      Change
                    </button>
                  </div> */}
                </div>
                {/* contect box end */}
                <br />

                {/* payment box start */}
                <p className="pg2_heading">Payment</p>
                <p className="pg2_des">
                  All transactions are secure and encrypted.
                </p>
                <div className="paymentbox_main_wrapp">
                  <div className="paymentbox_header">
                    <p className="pg2_heading">Credit card</p>
                    <div className="card_icon_div">
                      <img
                        src={images.visa}
                        className="item_img_card"
                        alt="Headphones"
                      />
                      <img
                        src={images.master}
                        className="item_img_card"
                        alt="Headphones"
                      />
                      <img
                        src={images.jcb}
                        className="item_img_card"
                        alt="Headphones"
                      />
                      <img
                        src={images.american}
                        className="item_img_card"
                        alt="Headphones"
                      />
                    </div>
                  </div>
                  {/* <div className="paymentbox_contain"> */}
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Card number"
                      className="card-number"
                      value={formatCardNumber(cardNumber)}
                      onChange={(e) => {
                        const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                        if (input.length <= 16) {
                          setCardNumber(input);
                        }
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Name on card"
                      className="card-number"
                      value={cardholdername}
                      onChange={(e) => setcardholdername(e.target.value)}
                    />
                  </div>
                  <div className="form-group-inline">
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Expiration date (MM/YY)"
                        className="expiry-date"
                        value={expiryDate}
                        onChange={(e) => {
                          let input = e.target.value;
                          // Remove non-numeric characters except "/"
                          input = input.replace(/\D/g, "");

                          // Ensure input is limited to 4 characters (MMYY format)
                          if (input.length > 4) {
                            input = input.slice(0, 4);
                          }

                          // Extract MM and YY
                          const month = input.slice(0, 2);
                          const year = input.slice(2, 4);

                          // Update state for ex_month and ex_year
                          setExMonth(month);
                          setExYear(year);

                          // Format input to display MM/YY in the input field
                          setExpiryDate(
                            month + (year.length > 0 ? "/" + year : "")
                          );
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder="Security code"
                        className="cvv"
                        value={cvv}
                        onChange={handleChange}
                        maxLength={4}
                      />
                    </div>
                  </div>
                  {/* </div> */}
                </div>
                {/* payment box end */}
                <br />
                {/* billing address start */}

                <p className="pg2_heading">Billing address</p>
                <p className="pg2_des">
                  Select the address that matches your card or payment method.
                </p>

                <div className="paymentbox_main_wrapp">
                  <div
                    className="addressbox_header"
                    onClick={() => setSameAsShipping(true)}
                  >
                    <input
                      type="radio"
                      name="addressOption"
                      value="same"
                      checked={sameAsShipping}
                      onChange={() => setSameAsShipping(true)}
                      className="address_box_radio"
                    />
                    <p className="pg2_heading">Same as shipping address</p>
                  </div>
                  <div
                    className="addressbox_header"
                    onClick={() => setSameAsShipping(false)}
                  >
                    <input
                      type="radio"
                      name="addressOption"
                      value="different"
                      checked={!sameAsShipping}
                      onChange={() => setSameAsShipping(false)}
                      className="address_box_radio"
                    />
                    <p className="pg2_heading">
                      Use a different billing address
                    </p>
                  </div>
                  {/* Billing Address Form (conditionally rendered) */}
                  {!sameAsShipping && (
                    <div className="same_as_shipping_form-2">
                      <select
                        value={country2}
                        onChange={(e) => setCountry2(e.target.value)}
                      >
                        <option>United States</option>
                        {/* Add more country options here */}
                      </select>
                      <div className="form-group-inline">
                        <div className="form-group min-width-50">
                          <input
                            type="text"
                            placeholder="First Name"
                            value={firstName2}
                            onChange={(e) => setFirstName2(e.target.value)}
                          />
                        </div>
                        <div className="form-group min-width-50">
                          <input
                            type="text"
                            placeholder="Last Name"
                            value={lastName2}
                            onChange={(e) => setLastName2(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <input
                          ref={inputRef2}
                          type="text"
                          placeholder="Address"
                          value={address2}
                          // onChange={(e) => setAddress2(e.target.value)}
                          onChange={(e) => {
                            if (e.target.value.length == 0) {
                              setSelectedState2({
                                name: "",
                                state_code: "",
                              });
                              setSelectedStateCode2({
                                name: "",
                                state_code: "",
                              });
                              setCity2("");
                              setPostalCode2("");
                            }
                            setAddress2(e.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group-inline">
                        <div className="inline_seond">
                          <select
                            value={JSON.stringify({
                              name: getselectedState2.name,
                              state_code: getselectedState2.state_code,
                            })}
                            onChange={(e) => {
                              console.log("getselectedStateCode-----", e);
                              const selectedState = JSON.parse(e.target.value);
                              // setSelectedState2(selectedState.name);
                              // setSelectedStateCode2(selectedState.state_code);
                              setSelectedState2({
                                name: selectedState.name,
                                state_code: selectedState.state_code,
                              });
                              setSelectedStateCode2({
                                name: selectedState.name,
                                state_code: selectedState.state_code,
                              });
                              handleStateChange2(selectedState.name);
                              console.log(
                                "getselectedStateCode111",
                                getselectedStateCode
                              );
                            }}
                          >
                            <option
                              value={JSON.stringify({
                                name: "",
                                state_code: "",
                              })}
                            >
                              Select state
                            </option>{" "}
                            {getstate &&
                              getstate.map((states, index) => {
                                return (
                                  <option
                                    value={JSON.stringify({
                                      name: states.name,
                                      state_code: states.state_code,
                                    })}
                                  >
                                    {states.name}
                                  </option>
                                );
                              })}
                            {/* Add more state options here */}
                          </select>
                        </div>
                        <div className="inline_seond">
                          {iscityloading ? (
                            <div
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginBottom: "1rem",
                              }}
                            >
                              <div
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  border: "3px solid #e0e0e0",
                                  borderTop: "3px solid #f39322",
                                  borderRadius: "50%",
                                  animation: "spin 1s linear infinite",
                                }}
                              ></div>
                            </div>
                          ) : (
                            // <select
                            //   value={city2}
                            //   onChange={(e) => {
                            //     setCity2(e.target.value);
                            //     setPostalCode2("");
                            //   }}
                            // >
                            //   <option value={""}>Select city</option>

                            //   {getallCitys.map((city, index) => {
                            //     return <option value={city}>{city}</option>;
                            //   })}
                            //   {/* Add more state options here */}
                            // </select>
                            <div
                              className="form-group"
                              style={{ width: "100%" }}
                            >
                              <input
                                type="text"
                                placeholder="City"
                                value={city2}
                                onChange={(e) => {
                                  setCity2(e.target.value);
                                  setPostalCode2("");
                                }}
                              />
                            </div>
                          )}
                        </div>

                        <div className="inline_seond">
                          <input
                            type="text"
                            placeholder="Postal Code"
                            value={postalCode2}
                            onChange={(e) => setPostalCode2(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Phone number"
                          value={phoneNumber2}
                          onChange={(e) => {
                            const input = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                            if (input.length <= 10) {
                              setPhoneNumber2(input);
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="features">
                  <ul style={{}}>
                    <li style={{ fontSize: "14px" }}>
                      Free online medical consultation.
                    </li>
                    <li style={{ fontSize: "14px" }}>
                      24/7 support via email or phone.
                    </li>
                    <li style={{ fontSize: "14px" }}>
                      100% refund if you are not prescribed.
                    </li>
                  </ul>
                </div>
                <br />
                <button
                  className="apply-button"
                  style={{ width: "100%" }}
                  onClick={Page2Validate}
                >
                  CHECKOUT NOW
                </button>

                <center>
                  <div className="ssl-secured-payment">
                    <FaLock />
                    <p
                      style={{
                        marginLeft: "5px",
                        fontSize: "16px",
                        color: "var(--clr-text)",
                        fontWeight: "400",
                      }}
                    >
                      SSL SECURED PAYMENT
                    </p>
                  </div>
                  <div>
                    <p
                      style={{
                        marginLeft: "5px",
                        fontSize: "16px",
                        color: "var(--clr-text)",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      Your information is protected by 256-bit SSL encryption
                    </p>
                  </div>
                </center>
              </div>
            )}
          </div>
          <div className="center_line"></div>
          <div className="order-summary2">
            <div className="checkout_logo_wrapp headline_for_mob">
              <img src={images.logo} className="" alt="" />

              <div className="checkout_head_name_wrapp">
                <p>Shipping</p>
                <FiChevronRight size={20} style={{ display: "block" }} />
                <p>Payment</p>
              </div>
            </div>
            <div
              className="product-info-right mb-2 mb:mt-0"
              // style={{ marginTop: "0px", marginBottom: "10px" }}
            >
              {(() => {
                const groupedProducts = getGroupedProductsForDisplay();
                return groupedProducts.length === 1 ? (
                  // Single product display
                  <>
                    <div className="product-image">
                      {groupedProducts[0].product_img &&
                      groupedProducts[0].product_img.length > 0 ? (
                        <img
                          src={groupedProducts[0].product_img[0]?.img_video}
                          alt="product-img"
                        />
                      ) : (
                        <img src={images.bottel_img} alt="product-img" />
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "80%",
                        alignItems: "center",
                      }}
                    >
                      <div className="product-details">
                        <h4>
                          {groupedProducts[0]?.product_name}
                          {groupedProducts[0].quantity > 1 && (
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: "400",
                                color: "#666",
                                marginLeft: "8px",
                              }}
                            >
                              (Qty: {groupedProducts[0].quantity})
                            </span>
                          )}
                        </h4>
                      </div>
                      <div style={{}} className="product-price">
                        <span className="discounted-price">
                          ${calculateSubtotal().toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </>
                ) : (
                  // Multiple products display
                  <div style={{ width: "100%" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        // marginBottom: "12px",
                        maxHeight: "130px",
                        overflow: "auto",
                      }}
                    >
                      {groupedProducts.map((product, index) => (
                        <div
                          key={product.product_id || index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            // backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            border: "1px solid #e9ecef",
                            width: "100%",
                          }}
                        >
                          <img
                            src={
                              product?.product_img &&
                              product.product_img.length > 0
                                ? product.product_img[0]?.img_video
                                : images.bottel_img
                            }
                            alt="product"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "contain",
                              borderRadius: "6px",
                              marginRight: "12px",
                            }}
                          />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <p
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                margin: 0,
                                color: "#000",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {product.product_name}
                              {product.quantity > 1 && (
                                <span
                                  style={{
                                    fontSize: "11px",
                                    fontWeight: "400",
                                    color: "#666",
                                    marginLeft: "6px",
                                  }}
                                >
                                  (Qty: {product.quantity})
                                </span>
                              )}
                            </p>
                            <p
                              style={{
                                fontSize: "11px",
                                margin: "2px 0 0 0",
                                color: "#000",
                                fontWeight: "600",
                              }}
                            >
                              {(() => {
                                // Use original price for discount calculations to prevent m_price interference
                                const productId = product.product_id;
                                const originalPrice = originalProductPrices.get(productId);
                                const productPrice = originalPrice !== undefined ? originalPrice : parseFloat(product.product_price);
                                const discountPercentValue = parseDiscountValue(discount_percent);
                                const discountAmountValue = parseDiscountValue(discount_amount);
                                
                                let discountedPrice = productPrice;
                                
                                if (discountPercentValue > 0) {
                                  discountedPrice = productPrice - (productPrice * discountPercentValue / 100);
                                } else if (discountAmountValue > 0) {
                                  // For discount_amount, calculate proportionally based on product price vs total
                                  // Use getBaseTotalPrice() which uses original prices
                                  const totalPrice = getBaseTotalPrice();
                                  const productDiscount = totalPrice > 0 ? (productPrice / totalPrice) * discountAmountValue : 0;
                                  discountedPrice = productPrice - productDiscount;
                                }
                                
                                // Ensure price never goes below 0
                                discountedPrice = Math.max(0, discountedPrice);
                                return "$" + discountedPrice.toFixed(2);
                              })()}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}
            </div>
            {/* Discount Code */}
            <div className="discount-code-section">
              <input
                style={{ width: "75%" }}
                type="text"
                placeholder="Discount Code"
                className="input-field"
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
              />
              <button
                style={{ width: "25%" }}
                onClick={handleApplyDiscount}
                className="apply-button"
                disabled={isloading || isProductLoading}
              >
                Apply
              </button>
            </div>
            {/* Display error message */}
            {error && (
              <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
            )}
            {applyLoading && (
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    border: "3px solid #e0e0e0",
                    borderTop: "3px solid var(--clr-main)",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
              </div>
            )}
            {/* Display discount badge on success */}
            {appliedDiscount && (
              <div
                style={{
                  marginTop: "10px",
                  backgroundColor: "#e0f7fa",
                  padding: "5px 10px",
                  display: "inline-block",
                  borderRadius: "5px",
                  width: "fit-content",
                  display: "flex",
                }}
              >
                <span style={{ color: "#00796b" }}>
                  ✅ {appliedDiscount} Applied
                </span>
                <button
                  onClick={handleRemoveDiscount}
                  style={{
                    marginLeft: "10px",
                    backgroundColor: "#230359",
                    color: "white",
                    border: "none",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                  className="remove_coupen_btn"
                >
                  <IoCloseOutline />
                </button>
              </div>
            )}

            {/* Order Summary */}
            <div
              style={{
                marginTop: "10px",
                backgroundColor: "var(--clr-card-bg)",
              }}
              className="order-summary2"
            >
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "500",
                  marginTop: "0px",
                  color: "var(--clr-text)",
                }}
                className="order-summary-title"
              >
                Order Summary
              </p>
              <hr className="order_summery_hr" />

              {/* Render all products */}
              <>
                <>
                  {(getproducts?.length > 0 ? getproducts : [getdata]).map(
                    (product, index) => (
                      <div key={product.product_id || index} className="item">
                        <img
                          src={
                            product?.product_img &&
                            product.product_img.length > 0
                              ? product.product_img[0]?.img_video
                              : images.bottel_img
                          }
                          className="order_summary_img"
                          alt="your medication"
                        />
                        <div className="div_card">
                          <p>{product?.product_name}</p>
                          <div className="product-price">
                            {/* Show original price if different from product_price */}
                            {product.original_price &&
                              parseFloat(product.original_price) !==
                                parseFloat(product.product_price) && (
                                <span
                                  className="original-price"
                                  style={{
                                    marginRight: "10px",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  $
                                  {parseFloat(product.original_price).toFixed(
                                    2
                                  )}
                                </span>
                              )}
                            <span className="discounted-price">
                              {product.product_price != null &&
                              !isNaN(product.product_price)
                                ? (() => {
                                    // Use original price for discount calculations to prevent m_price interference
                                    const productId = product.product_id;
                                    const originalPrice = originalProductPrices.get(productId);
                                    const productPrice = originalPrice !== undefined ? originalPrice : parseFloat(product.product_price);
                                    const discountPercentValue = parseDiscountValue(discount_percent);
                                    const discountAmountValue = parseDiscountValue(discount_amount);
                                    
                                    let discountedPrice = productPrice;
                                    
                                    if (discountPercentValue > 0) {
                                      discountedPrice = productPrice - (productPrice * discountPercentValue / 100);
                                    } else if (discountAmountValue > 0) {
                                      // For discount_amount, calculate proportionally based on product price vs total
                                      // Use getBaseTotalPrice() which uses original prices
                                      const totalPrice = getBaseTotalPrice();
                                      const productDiscount = totalPrice > 0 ? (productPrice / totalPrice) * discountAmountValue : 0;
                                      discountedPrice = productPrice - productDiscount;
                                    }
                                    
                                    // Ensure price never goes below 0
                                    discountedPrice = Math.max(0, discountedPrice);
                                    return "$" + discountedPrice.toFixed(2);
                                  })()
                                : "$" + product.product_price}
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </>
              </>
              <div className="item">
                <div
                  style={{
                    padding: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "70px",
                    border: "1px solid var(--clr-border)",
                    borderRadius: "5px",
                  }}
                >
                  <Stethoscope size={30} color="#000" />
                </div>
                <div className="div_card">
                  <p>Doctor Support and Monitoring</p>
                  <div style={{}} className="product-price">
                    <span
                      style={{ marginRight: "10px" }}
                      className="original-price"
                    >
                      $99
                    </span>
                    <span className="discounted-price">free</span>
                  </div>
                </div>
              </div>

              <div className="item">
                <div
                  style={{
                    padding: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "70px",
                    border: "1px solid var(--clr-border)",
                    borderRadius: "5px",
                  }}
                >
                  <Truck size={30} color="#000" />
                </div>
                <div className="div_card">
                  <p>{"Shipping"}</p>
                  {/* <p>{shippingName || "Overnight Shipping"}</p> */}
                  <div style={{}} className="product-price">
                    {parseFloat(shippingCost) > 0 ? (
                      <>
                        {/* <span
                          style={{ marginRight: "10px" }}
                          className="original-price"
                        >
                          $40
                        </span> */}
                        <span className="discounted-price">
                          ${parseFloat(shippingCost).toFixed(2)}
                        </span>
                      </>
                    ) : (
                      <>
                        <span
                          style={{ marginRight: "10px" }}
                          className="original-price"
                        >
                          $40
                        </span>
                        <span className="discounted-price">free</span>
                      </>
                    )}
                  </div>
                </div>
              </div>

              {appliedDiscount && (
                <div className="savings-banner">
                  <MdOutlineCelebration size={25} />
                  <span>
                    You saved{" "}
                    {(() => {
                      const discountPercentValue = parseDiscountValue(discount_percent);
                      const discountAmountValue = parseDiscountValue(discount_amount);
                      if (discountPercentValue > 0) {
                        return `${Math.trunc(discountPercentValue)}%`;
                      } else if (discountAmountValue > 0) {
                        return "$" + discountAmountValue.toFixed(2);
                      }
                      return "$0.00";
                    })()}{" "}
                    on your order
                  </span>
                </div>
              )}
              <div
                className="your-total-div"
                style={{
                  borderRadius: "5px",
                  border: isExpanded ? "1px solid var(--clr-border)" : "",
                }}
              >
                <div
                  style={{
                    borderRadius: "5px",
                    border: isExpanded ? "" : "1px solid var(--clr-border)",
                  }}
                  className={`total-section ${isExpanded ? "expanded" : ""}`}
                  onClick={handleExpandClick}
                >
                  <div className="total-details">
                    <CiStar
                      size={25}
                      color="var(--clr-main)"
                      className="star_icon"
                    />
                    <span style={{ color: "var(--clr-main)" }}>
                      {totalText} ${calculateTotal().toFixed(2)}
                    </span>
                    <div className="expand-button">
                      <span>
                        {isExpanded ? <FaAngleUp /> : <FaAngleDown />}
                      </span>
                    </div>
                  </div>
                </div>

                {isExpanded && (
                  <div style={{ margin: "10px" }} className="expanded-content">
                    {/* Add your expanded content here */}
                    <div
                      style={{
                        borderTop: "0.5px solid var(--clr-border)",
                        marginTop: "-10px",
                        marginBottom: "20px",
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <p style={{ color: "var(--clr-text)", fontSize: "15px" }}>
                        Subtotal
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "var(--clr-text)",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          ${getBaseTotalPrice().toFixed(2)}
                        </span>
                      </div>
                    </div>
                    {appliedDiscount && getDiscountAmount() > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <p style={{ color: "var(--clr-text)", fontSize: "15px" }}>
                          Discount ({appliedDiscount})
                        </p>
                        <div style={{}} className="product-price">
                          <span
                            style={{
                              marginRight: "10px",
                              color: "#4caf50",
                              fontSize: "15px",
                              fontWeight: "600",
                            }}
                            className="originsal-price"
                          >
                            -${getDiscountAmount().toFixed(2)}
                          </span>
                        </div>
                      </div>
                    )}
                    {appliedDiscount && (
                      <div className="div_card" style={{ width: "100%", marginTop: "10px" }}>
                        <p
                          style={{
                            fontWeight: "600",
                            color: "var(--clr-text)",
                          }}
                        >
                          Your Coupon Savings
                        </p>
                        <div style={{}} className="product-price">
                          <span
                            style={{ marginRight: "10px", color: "#4caf50" }}
                            className="originsal-price"
                          >
                            {(() => {
                              const discountPercentValue = parseDiscountValue(discount_percent);
                              const discountAmountValue = parseDiscountValue(discount_amount);
                              if (discountPercentValue > 0) {
                                return `${Math.trunc(discountPercentValue)}%`;
                              } else if (discountAmountValue > 0) {
                                return "$" + discountAmountValue.toFixed(2);
                              }
                              return "0%";
                            })()}
                          </span>
                        </div>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                        borderTop: "1px solid var(--clr-border)",
                        paddingTop: "10px",
                      }}
                    >
                      <p style={{ color: "var(--clr-text)", fontSize: "15px", fontWeight: "600" }}>
                        Total
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "var(--clr-text)",
                            fontSize: "15px",
                            fontWeight: "600",
                          }}
                          className="originsal-price"
                        >
                          ${calculateSubtotal().toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <p style={{ color: "var(--clr-text)", fontSize: "15px" }}>
                        Estimated Tax
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "var(--clr-text)",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          ---
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <p style={{ color: "var(--clr-text)", fontSize: "15px" }}>
                        Shipping
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "var(--clr-text)",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          ${(parseFloat(shippingCost) || 0).toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        borderTop: "0.5px solid var(--clr-border)",
                        marginTop: "10px",
                        marginBottom: "10px",
                        // width: "90%",
                      }}
                    />
                    <div
                      className="div_card"
                      style={{ width: "100%", alignItems: "center" }}
                    >
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                          color: "var(--clr-text)",
                        }}
                      >
                        Total
                      </p>
                      <div style={{}} className="product-price">
                        <span
                          style={{
                            marginRight: "10px",
                            color: "var(--clr-text)",
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                          className="originsal-price"
                        >
                          ${calculateTotal().toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: "20px",
                        borderRadius: "5px",
                        border: "1px solid var(--clr-main)",
                        padding: "20px",
                        backgroundColor: "rgba(99, 243, 255, 0.1)",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "10px",
                          lineHeight: "22px",
                          color: "var(--clr-text)",
                        }}
                      >
                        By clicking the "Checkout Now" button above, your card
                        will be billed the total amount of $
                        {calculateTotal().toFixed(2)} today to reserve your 1
                        month supply of your medication. After you complete the
                        order by clicking the secure "Checkout Now" button
                        above, your information will be securely saved. You will
                        then be asked to complete a short medical history intake
                        and verify your identity. A pharmazee medical
                        professional will review your information, and, if
                        appropriate, prescribe your medication. If you are not
                        eligible for your medication for ANY reason, you will
                        receive a full refund of your purchase price. You have
                        selected the monthly package, which includes a 1 month
                        starter kit. The starter kit includes your medication
                        and detailed instructions on how to properly administer
                        the medication. Each month, you will need to update your
                        prescribing doctor on your progress and they will have
                        the ability to adjust your dosage as needed. Your new
                        billing will continue at ${getdata.product_price} per
                        month after the first 21 days. It will include your
                        medication, unlimited doctor support, and prescription
                        covered. If at anytime you decide not to continue,
                        simply contect us info@pharmazee.com. You will not be
                        billed further. While you are a member, you will have
                        access to chat with your doctor or customer support for
                        any needed assistance.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {getskipModel && (
          <div className="skip_modal_main_wrapp">
            <div className="skip_white_part_wrapp">
              <p className="f-16 fw-500" style={{ marginBottom: "10px" }}>
                Thank you for your order
              </p>
              {/* {getdata.is_intake === "0" ?  <p className="f-16 fw-500 mb-2">
               You are now being redirected to the Medical Intake form to complete process
              </p> :
           } */}{" "}
              <p className="f-16 fw-500 mb-2">
                You are now being redirected to your Member Portal
              </p>
              <div>
                <button
                  className="btn"
                  style={{ width: "100px" }}
                  onClick={() => {
                    // SkipNextMonth();
                    setSkipModel(false);
                    window.location.assign(memberPortalUrl);
                  }}
                >
                  OK
                </button>
                {/* <p className="f-14 fw-400">Redirecting in {countdown} seconds...</p> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Checkout2;
